import { Injectable } from "@angular/core";
import { HttpClient } from "@angular/common/http";
import moment from "moment";

@Injectable({
  providedIn: "root",
})
export class RequestService {
  public list: any = [];

  public stepList: any = [];

  public suitablesUsersList: any = [];

  public candidateRequests: any = [];

  public eligibleUsersForList: any = [];

  constructor(private _httpClient: HttpClient) {}

  createRequestTitle(request: any) {
    return `#${request.id} - ${request.client} - ${request.figure}`;
  }

  //Get per tutte le richieste
  async getRequestList(): Promise<any> {
    return this._httpClient
      .get("/request")
      .toPromise()
      .then((response) => {
        this.list = response;
        return response;
      });
  }

  //Azioni per le richieste singole
  async getRequest(id: number): Promise<any> {
    return this._httpClient
      .get("/request/" + id)
      .toPromise()
      .then((response) => {
        this.list = response;
        return response;
      });
  }

  async createRequest(data: any = {}): Promise<any> {
    return this._httpClient
      .post("/request", data)
      .toPromise()
      .then((response) => {
        this.list = response;
        return response;
      });
  }

  async deleteRequest(id: number): Promise<any> {
    return this._httpClient
      .delete("/request/" + id)
      .toPromise()
      .then((response) => {
        this.list = response;
        return response;
      });
  }

  async editRequest(id: number, data: any): Promise<any> {
    return this._httpClient
      .put("/request/" + id, data)
      .toPromise()
      .then((response) => {
        this.list = response;
        return response;
      });
  }

  async getSuitablesCandidate(id: any, user_type: string): Promise<any> {
    return this._httpClient
      .get("/request/" + id + "/match/" + user_type)
      .toPromise()
      .then((response) => {
        this.suitablesUsersList = response;
        return response;
      });
  }

  async getSteps(id: number): Promise<any> {
    return this._httpClient
      .get("/request-step/" + id)
      .toPromise()
      .then((response) => {
        return response;
      });
  }

  //Funzione che ha come contenuto sia le richieste(e in essa tutto lo storico degli step del utente per quella richiesta(timeLine)
  async getSingleCandidateRequests(hash: string): Promise<any> {
    return this._httpClient
      .get("/user-request/" + hash)
      .toPromise()
      .then((response) => {
        this.candidateRequests = response;
        return response;
      });
  }

  async insertStep(data: any = {}): Promise<any> {
    return this._httpClient
      .post("/request-step", data)
      .toPromise()
      .then((response) => {
        this.stepList = response;
        return response;
      });
  }

  //funzione per caricare candidati o dipendenti che sono entrati nella fase di idoneità per una richiesta cliente
  async getEligibleUsers(from: string = moment().startOf('year').format('YYYY-MM-DD'), to: string = moment().format('YYYY-MM-DD')): Promise<any> {
    return this._httpClient
      .get(`/request-list-step/${from}/${to}`)
      .toPromise()
      .then((response) => {
        this.eligibleUsersForList = response;
        return response;
      });
  }

  async closeRequest(id: number, data: any): Promise<any> {
    return this._httpClient.put("/request/" + id + "/close", data).toPromise();
  }

  async reOpenRequest(id: number, data: any = {}): Promise<any> {
    return this._httpClient.put("/request/" + id + "/open", data).toPromise();
  }
}
